import { z } from 'zod';

import type { VoidShipmentRequest, VoidShipmentResponse } from './void-shipment.dto.js';
import {
  ShipmentHeaderSchema,
  ShipmentTotalsSummarySchema,
} from './shipments-shared.schema.js';

export const VoidShipmentRequestSchema: z.ZodType<VoidShipmentRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
    stationId: z.uuid(),
    reason: z.string().trim().min(1),
  })
  .strict();

export const VoidShipmentResponseSchema: z.ZodType<VoidShipmentResponse> = z
  .object({
    shipment: ShipmentHeaderSchema,
    totals: ShipmentTotalsSummarySchema,
  })
  .strict();
